import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=f703ebce&scoped=true&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentPage.vue?vue&type=style&index=0&id=f703ebce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703ebce",
  null
  
)

export default component.exports